import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Governanca from './views/Governanca.vue';
import Pessoas from './views/Pessoas.vue';
import Orcamentos from './views/Orcamentos.vue';
import AtosOficiais from './views/gestao/AtosOficiais.vue';
import AtosOficiaisSubCategorias from './views/gestao/AtosOficiaisSubcategorias.vue';
import AtosOficiaisCategorias from './views/gestao/Categorias.vue';
import PessoasCategory from './views/pessoas/Category.vue';
import OrcamentosListagem from './views/Orcamentos/Orcamentos.vue';
import OrcamentosDespesas from './views/Orcamentos/Despesas.vue';
import OrcamentosReceitas from './views/Orcamentos/Receitas.vue';
import DescicaoMesesDespesas from './views/Orcamentos/DescricaoMesesDespesas.vue';
import SingleDespesas from './views/Orcamentos/SingleDespesas.vue';
import SingleReceitas from './views/Orcamentos/SingleReceitas.vue';
import Organograma from './views/gestao/Organograma.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/gestaoegovernanca',
      name: 'governanca',
      component: Governanca,
    },
    {
      path: '/gestaoegovernanca/organograma',
      name: 'governanca-organograma',
      component: Organograma,
    },
    {
      path: '/gestaoegovernanca/atosoficiais',
      name: 'atosoficiais',
      component: AtosOficiais,
    },
    {
      path: '/gestaoegovernanca/atosoficiais/:category',
      name: 'atosoficiais-category',
      component: AtosOficiaisSubCategorias,
    },
    {
      path: '/gestaoegovernanca/atosoficiais/:category/:subcategory/:year',
      name: 'atosoficiais-subcategory',
      component: AtosOficiaisCategorias,
    },
    {
      path: '/gestaodepessoas',
      name: 'pessoas',
      component: Pessoas,
    },{
      path: '/gestaodepessoas/:category',
      name: 'pessoas-category',
      component: PessoasCategory,
    },
    {
      path: '/orcamentosefinancas',
      name: 'orcamentos',
      component: Orcamentos,
    },
    {
      path: '/orcamentosefinancas/orcamentos',
      name: 'orcamentos-listagem',
      component: OrcamentosListagem,
    },
    {
      path: '/orcamentosefinancas/despesas/:branch/:year',
      name: 'despesas',
      component: OrcamentosDespesas,
    },
    {
      path: '/orcamentosefinancas/despesas/:branch/:year/:category',
      name: 'despesas-mes',
      component: DescicaoMesesDespesas,
    },
    {
      path: '/orcamentosefinancas/despesas/:branch/:year/:category/:month',
      name: 'despesas-internas',
      component: SingleDespesas,
    },
    {
      path: '/orcamentosefinancas/receitas/:branch/:year',
      name: 'receitas',
      component: OrcamentosReceitas,
    },
    {
      path: '/orcamentosefinancas/receitas/:branch/:year/:category/:month',
      name: 'receitas-ano-mes',
      component: SingleReceitas,
    },
  ],
});
